import React from "react";
import {
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import useStyles from "components/Home/Styles";

const HomeView = () => {
  const classes = useStyles();

  return (
    <Container>
      <Grid
        item
        container
        xs={12}
        justify="center"
        alignContent="center"
        alignItems="center"
      >
        <Card className={classes.root}>
          <CardContent>
            <Typography variant="body2" component="p">
              Home page
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Container>
  );
};

export default HomeView;
